import { apiConfig } from '../api-config';

export interface UpdateRegisterParams {
  territoryId: string;
  tokenKey: string;
  status: string;
}

export const updateConstestation = async (params: UpdateRegisterParams) => {
  return apiConfig
    .post('api/Contestation/update', params)
    .then((resp) => resp.data)
    .catch((err) => ({ hasErros: true, err }));
};
